import { URL_API } from '../Configuracion/configuracion';
import { http_helper } from '../Helpers/http_helper';
import Api from '../api';

export const loginService = { registro };

let api = http_helper();
let uri = '/api/ed/auth'

export const AuthUser = (data) => {
    return Api.getInstance().executeQuery(uri, data)
        .then(res => res)
        .catch(err => console.log(err));
}


export const RegisterUser = (data) => {
    return Api.getInstance().executeQuery('/api/ed/registro', data)
        .then(res => res)
        .catch(err => console.log(err));
}

function registro(data) {

    return api.post(`${URL_API}${uri}`,
        {
            body:
            {
                user: data.user,
                estado: 1,
                idRol: 2,
                nombre: data.nombre,
                apellido: data.apellido
            }
        });
}